
import { Utils } from '../utils/Utils';
import { SmoothScroll } from '../utils/SmoothScroll';

export const Roles = {
  locations: [],
  departments: [],
  roles: [],
  onLoad: function() {
    SmoothScroll.onInit();
    this.getJobs();
  },
  getJobs: function() {
    const requestUrl = 'https://api.lever.co/v0/postings/tubularlabs?mode=json';
    $.ajax({
      url: requestUrl,
      // data: ajaxData,
      dataType: 'json',
      type: 'GET',
      error: (err) => {
        console.error(err);
      },
      success: (response) => {
        // console.log('response data', response);
        if (response) {
          // list roles
          Roles.listDepartmentRoles(response);
          // setup filters
          if (response.length > 1) {
            Roles.setupDepartmentsFilter(response);
            Roles.setupLocationsFilter(response);
            // todo: on listen to filters
            Roles.onListenToFilters();
          }
        } else {
          $('#roles-loading, #roles-available').hide();
          $('#roles-none').show();
        }
      },
    });
  },
  setupDepartmentsFilter: function(jobs) {
    jobs.forEach( function(job) {
      const department_name = job.categories.team;
      const department_key = Utils.slugify(job.categories.team);
      if (!Roles.departments[department_key]) {
        Roles.departments[department_key] = {
          'department': job.categories.team,
          'roles': [],
        }
        const btn = '<button class="dropdown-item departments-dropdown-btn" href="#" value="' + department_key + '" data-type="department">' + department_name + '</button>';
        $('#departmentsDropdownOptions').append(btn);
      }
    });
    $('#roles #departments-dropdown-wrap').show();
  },
  setupLocationsFilter: function(jobs) {
    jobs.forEach( function(job) {
      const location_name = job.categories.location;
      const location_key = Utils.slugify(location_name);
      if ( ! Roles.locations[location_key] ) {
        Roles.locations[location_key] = {
          'location': location_name,
        }
        const btn = '<button class="dropdown-item locations-dropdown-btn" href="#" value="' + location_key + '" data-type="location">' + location_name + '</button>';
        $('#locationsDropdownOptions').append(btn);
      }
    });
    $('#roles #locations-dropdown-wrap').show();
  },
  onListenToFilters: function() {
    $('#roles #filters .dropdown-item').on('click', function() {
      const value = Utils.slugify($(this).attr('value'));
      const type = $(this).attr('data-type');
      // roles-department
      // role-location
      if (value === 'all') {
        $('#roles .accordion').show();
        $('#roles .role').addClass('d-flex').removeClass('d-none');
      } else if (type === 'department') {
        $('#roles .accordion').each(function() {
          const department_name = Utils.slugify($(this).find('.department-name').text());
          if (value === department_name) {
            $(this).show();
            // show all the roles, incase they are hidden
            $(this).find('.role').addClass('d-flex').removeClass('d-none');
          } else {
            $(this).hide();
          }
        });
      } else if (type === 'location') {
        $('#roles .role').each(function() {
          const location_name = Utils.slugify($(this).find('.role-location').text());
          if (value === location_name) {
            $(this).addClass('d-flex').removeClass('d-none');
          } else {
            $(this).removeClass('d-flex').addClass('d-none');
          }
        });
      }
    });
  },
  listDepartmentRoles: function(roles) {
    $('#roles-loading').hide();
    const $roles_listing = $('#roles-available');
    const primary_color = $roles_listing.attr('primary-color');
    const secondary_color = $roles_listing.attr('secondary-color');
    const down_arrow_blue = $roles_listing.attr('down-arrow-blue');
    const close_blue = $roles_listing.attr('close-blue');
    const these_departments = [];
    if (roles.length) {
      // Setup Departments & Locations
      roles.forEach(function(role) {
        const new_department = {
          'name' : role.categories.team,
          'roles' : [role],
        };
        if (these_departments.length) {
          let department_found = false;
          these_departments.forEach(function(department) {
            if (department.name === new_department.name) {
              department.roles.push(role);
              department_found = true;
            }
          });
          if (!department_found) {
            these_departments.push(new_department);
          }
        } else {
          these_departments.push(new_department);
        }

        // const location_key = role.categories.location.replace(/\s+/g, '-').toLowerCase();
        // if location does NOT exists
        // if (these_departments.indexOf(location_key) === -1) {
        //   Roles.locations[location_key] = {
        //     'name' : role.categories.location,
        //   };
        // }
      });
      // let inc = 0;
      // Roles Accordions
      these_departments.forEach(function(department, department_key) {
        const margin_bottom_class = (department_key !== (roles.length - 1)) ? 'mb-4' : 'mb-0';
        const roles_count = department.roles.length;
        let roles_count_text = (roles_count !== 1) ? 'Open Roles': 'Open Role';
        let $department = '<div id="accordion' + department_key + '" class="accordion roles-department col-lg-6 mb-lg-4 ' + margin_bottom_class + ' will-fade-in fadeInUp">\
          <button class="btn btn-' + primary_color + ' text-' + secondary_color + ' w-100" type="button" data-toggle="collapse" data-target="#collapse' + department_key + '" aria-expanded="false" aria-controls="collapse' + department_key + '">\
            <div class="d-flex flex-row align-items-center justify-content-between header">\
              <strong class="department-name mr-2 text-left">' + department.name + '</strong>\
              <div class="d-flex flex-row">\
                <span class="mr-3 font-weight-light body-small"><span class="count">' + roles_count + '</span> ' + roles_count_text + '</span>\
                <img class="collapse-arrow" src="' + down_arrow_blue + '" alt="Dropwdown Arrow" width="18">\
                <img class="collapse-close" src="' + close_blue + '" alt="Dropwdown Close" width="18">\
              </div>\
            </div>\
          </button>\
          <div id="collapse' + department_key + '" class="collapse" data-parent="#accordion' + department_key + '">\
            <div class="card-body bg-' + primary_color + ' pb-0">';
              department.roles.forEach(function(role) {
                /* eslint-disable-next-line no-undef */
                const $new_role = '<a href="' + THEME.site_url + '/careers/role/' + role.id + '" class="role pb-4 px-1 d-flex flex-column flex-md-row align-items-md-center justify-content-between text-' + secondary_color + '" target="_blank">\
                    <h5 class="fs-1.25x mb-0">' + role.text + '</h5>\
                    <p class="role-location fs-1.25x mb-0">' + role.categories.location + '</p>\
                  </a>';
                $department += $new_role;
              });
            $department += '</div>\
          </div>\
        </div>';
        $roles_listing.append($department);
      });
    }
    $roles_listing.show();
  },
};



// WEBPACK FOOTER //
// ./scripts/layouts/Roles.js